/* eslint-disable unicorn/no-null */
import {
  TEXT_INPUT_FORMATS,
  type TextInputFormat,
} from 'src/tpbp-core/models/fields/text-input.const'
import { NUMBER_FORMATS } from 'src/tpbp-core/utils/formatter/formatter.const'
import { $n, $tc } from 'src/plugins/i18n'
import { stringToNumber } from 'src/tpbp-core/utils/common.utils'

export function getNumericValueToEmit(
  value: string,
  format?: TextInputFormat,
  disallowNegative = false,
) {
  if (value === '') {
    return null
  }
  const numericValue = stringToNumber(value, Number.NaN, disallowNegative)
  if (Number.isNaN(numericValue)) {
    return 0
  }
  const isCurrency = format
    ? [TEXT_INPUT_FORMATS.currency, TEXT_INPUT_FORMATS.currency2].includes(
        format,
      )
    : false

  return isCurrency ? Math.round(100 * numericValue) / 100 : numericValue
}

// eslint-disable-next-line unicorn/no-null
export function getFormattedNumber(
  value: null | string | number | undefined,
  format,
  isSymbolExcluded = false,
): string {
  // eslint-disable-next-line unicorn/no-null
  if (value === null || value === undefined || value === '') {
    return ''
  }
  if (typeof value !== 'number') {
    return value
  }

  if (format === TEXT_INPUT_FORMATS.currency) {
    return $n(
      value,
      isSymbolExcluded
        ? NUMBER_FORMATS.integer
        : NUMBER_FORMATS.conciseCurrency,
    )
  }
  if (format === TEXT_INPUT_FORMATS.currency2) {
    return $n(
      value,
      isSymbolExcluded ? NUMBER_FORMATS.parts : NUMBER_FORMATS.currency,
    )
  }
  if (format === TEXT_INPUT_FORMATS.month) {
    return $tc('common.months', value, { nb: value })
  }
  if (format === TEXT_INPUT_FORMATS.year) {
    return $tc('common.years', value, { nb: value })
  }
  if (format === TEXT_INPUT_FORMATS.percentage) {
    return isSymbolExcluded
      ? $n(value, NUMBER_FORMATS.integer)
      : $n(value / 100, NUMBER_FORMATS.concisePercent) // value / 100 because $n get a ratio
  }
  if (format === TEXT_INPUT_FORMATS.percentage2) {
    return isSymbolExcluded
      ? $n(value, NUMBER_FORMATS.parts)
      : $n(value / 100, NUMBER_FORMATS.percent)
  }
  if (format === NUMBER_FORMATS.percent2digits) {
    return isSymbolExcluded
      ? $n(value, NUMBER_FORMATS.twoDecimal)
      : $n(value / 100, NUMBER_FORMATS.percent2digits)
  }

  return value.toString()
}
